<template>
  <NavigationTemplateList>
    <template v-for="link in links" :key="link.url">
      <NavigationButtonIcon v-bind="link" />
      <!-- <NavigationButtonDiamond v-else v-bind="link" /> -->
    </template>

    <NavigationButtonEdit v-if="editable" />
  </NavigationTemplateList>
</template>
<script lang="ts" setup>
interface Props {
  disabled?: boolean;
  addSettings?: boolean;
  size?: 'small' | 'normal' | 'medium';
  variant?: 'tonal' | 'outlined';
  type?: 'default' | 'statistics' | 'nomad';
}

const props = defineProps({
  disabled: { type: Boolean, default: false },
  addSettings: { type: Boolean, default: true },
  size: { default: 'medium' },
  variant: { default: 'tonal' },
  type: { default: 'default' }
});

const profile = useProfileStore();

const { contentUserTypeFromRoute } = useContentRouteHelper();

const { all } = useContentsForUserType(contentUserTypeFromRoute.value);

const editable = computed(() => {
  if (props.type !== 'default') return false;
  if (!profile.isParent) return true;
  return contentUserTypeFromRoute.value === ContentUserType.Default;
});

const links = computed(() => {
  return all.value.map((item) => {
    const url =
      props.type === 'statistics' ? `/mes-statistiques/${item.slug}` : item.url;
    const hasIconBook = [
      'mainContent',
      'previousContent',
      'childrenContent',
    ].includes(item.type);
    let label = `${item.name}`;
    if (
      profile.isParent &&
      item.type === 'childrenContent' &&
      item.memberName
    ) {
      label = `${item.memberName} ( ${item.name} )`;
    }
    return {
      url,
      label,
      iconName: hasIconBook ? 'nomad:book' : 'nomad:diamond',
    };
  });
});
</script>
